import { FeatureKey } from '../../_models/feature';
import { isNavigableSubFeature } from '../../shared/ecpl-tab-navigation/tab-navigation.rules';

/**
 * The Follow-up tabs, in feature JSON order. Shared by the Follow-up page and
 * the hover sub-navigation so both list the same tabs.
 * @param children Children of the Follow-up feature node.
 * @param roleId Current role id (`BaseServices.roleId`).
 * @param isRemote Whether this window is in R mode.
 */
export function followUpTabs(
  children: any[] | null | undefined,
  roleId: string,
  isRemote: boolean
): any[] {
  let tabs = (children ?? []).filter(isNavigableSubFeature);
  if (isRemote) {
    tabs = tabs.filter(tab => tab.translationKey !== 'MESSAGING');
  }
  if (+roleId === 1) {
    // JIRA ID= kw-285
    tabs = tabs.filter(
      tab =>
        tab.id !== FeatureKey.MESSAGES && tab.id !== FeatureKey.SUGGESTION_BOX
    );
  }
  return tabs;
}
